

// const endpoint='https://mentoring-400802.ue.r.appspot.com'
const endpoint =process.env.REACT_APP_BACKEND_ENDPOINT;
//above one is working
// const endpoint='https://dev.techpact.org/flaskapp'
// const endpoint='https://dev.techpact.org/flaskapp'
// const endpoint='http://127.0.0.1:5000'
// const endpoint='https://us-central1-notification-services-a7297.cloudfunctions.net/api/'

export default endpoint